import React from "react";

function LocationIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            fill="none"
            viewBox="0 0 34 34"
        >
            <mask
                id="mask0_0_5181"
                style={{ maskType: "alpha" }}
                width="34"
                height="34"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#D9D9D9"
                    d="M0.906 0.936H33.164V33.194H0.906z"
                ></path>
            </mask>
            <g mask="url(#mask0_0_5181)">
                <path
                    fill="#000"
                    d="M16.682 26.52c-1.128-1.737-3.05-5.097-4.43-8.279-.963-2.22-1.666-4.367-1.666-5.852a6.68 6.68 0 011.89-4.675l.002-.003a6.355 6.355 0 014.56-1.937c1.779 0 3.392.741 4.56 1.938l.003.003a6.68 6.68 0 011.888 4.674c0 1.485-.703 3.631-1.666 5.852-1.381 3.185-3.306 6.548-4.433 8.284a.416.416 0 01-.708-.006zm-2.292 1.835a.43.43 0 01-.423-.434c0-.24.19-.434.423-.434h5.295a.43.43 0 01.423.434.43.43 0 01-.423.434H14.39zM17.037 9.11c.882 0 1.68.368 2.26.96l.003.003c.578.594.936 1.413.936 2.316 0 .906-.359 1.726-.937 2.319a3.15 3.15 0 01-2.262.96 3.151 3.151 0 01-2.262-.96 3.312 3.312 0 01-.936-2.319c0-.903.358-1.723.936-2.316l.003-.003a3.15 3.15 0 012.259-.96zm1.664 1.574a2.315 2.315 0 00-3.326 0 2.435 2.435 0 00-.69 1.705c0 .666.264 1.27.69 1.705a2.317 2.317 0 001.662.706c.65 0 1.238-.27 1.663-.706a2.435 2.435 0 00.689-1.705c0-.666-.263-1.27-.688-1.705zm-5.679 7.205c1.225 2.823 2.886 5.792 4.016 7.604 1.129-1.812 2.79-4.781 4.015-7.604.918-2.118 1.589-4.144 1.589-5.5a5.8 5.8 0 00-1.64-4.062 5.519 5.519 0 00-3.965-1.683c-1.548 0-2.95.643-3.962 1.681a5.802 5.802 0 00-1.642 4.065c0 1.355.67 3.381 1.59 5.5z"
                ></path>
            </g>
        </svg>
    );
}

export default LocationIcon;
